(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2393],{

/***/ 65468:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reels",
      function () {
        return __webpack_require__(29566);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_reels; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./features/reels/const.ts


var VideoReelsDefault = {
    edges: [],
    count: 0
};
var ActionType;
(function(ActionType) {
    ActionType["OnLoadMore"] = "OnLoadMore";
    ActionType["SetData"] = "SetData";
    ActionType["AppendData"] = "AppendData";
    ActionType["UpdateVideo"] = "UpdateVideo";
    ActionType["ToggleLike"] = "ToggleLike";
})(ActionType || (ActionType = {}));
var videoReelsQueryBuilder = function(filters) {
    var limit = filters.limit, offset = filters.offset, created_at_from = filters.created_at_from, created_at_to = filters.created_at_to, staff_id = filters.staff_id, sort_by = filters.sort_by, sort = filters.sort;
    var payload = {};
    payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
        limit: limit,
        offset: offset,
        created_at_from: created_at_from,
        created_at_to: created_at_to,
        staff_id: staff_id,
        sort_by: sort_by,
        sort: sort
    });
    return payload;
};
var FormChatDefault = {
    comment: ""
};

// EXTERNAL MODULE: ./libs/axios/index.ts
var axios = __webpack_require__(80787);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
;// CONCATENATED MODULE: ./features/reels/api.ts



var ApiUrl = {
    REEL: "/api/v1/reel",
    COMMENT: "/api/v1/reel/comment",
    COMMENT_REPLY: "/api/v1/reel/comment/reply"
};
var fetchVideoReels = function(params) {
    return axios/* default.get */.ZP.get(ApiUrl.REEL, {
        params: params
    });
};
var getVideoDetail = function(id) {
    return axios/* default.get */.ZP.get("".concat(ApiUrl.REEL, "/").concat(id));
};
var fetchComments = function(reelId, params) {
    return axios/* default.get */.ZP.get("".concat(ApiUrl.REEL, "/").concat(reelId, "/comment"), {
        params: params
    });
};
var fetchReplyComments = function(commentId, params) {
    return axios/* default.get */.ZP.get("".concat(ApiUrl.COMMENT, "/").concat(commentId, "/reply"), {
        params: params
    });
};
var createComment = function(param) {
    var reelId = param.reelId, body = param.body;
    return axios/* default.post */.ZP.post("".concat(ApiUrl.REEL, "/").concat(reelId, "/comment"), body);
};
var updateComment = function(param) {
    var commentId = param.commentId, body = param.body;
    return axios/* default.put */.ZP.put("".concat(ApiUrl.COMMENT, "/").concat(commentId), body);
};
var deleteComment = function(commentId) {
    return axios/* default.delete */.ZP["delete"]("".concat(ApiUrl.COMMENT, "/").concat(commentId));
};
var createReplyComment = function(param) {
    var commentId = param.commentId, body = param.body;
    return axios/* default.post */.ZP.post("".concat(ApiUrl.COMMENT, "/").concat(commentId, "/reply"), body);
};
var updateReplyComment = function(param) {
    var commentId = param.commentId, body = param.body;
    return axios/* default.put */.ZP.put("".concat(ApiUrl.COMMENT_REPLY, "/").concat(commentId), body);
};
var deleteReplyComment = function(commentId) {
    return axios/* default.delete */.ZP["delete"]("".concat(ApiUrl.COMMENT_REPLY, "/").concat(commentId));
};
var createLike = function(reelId, body) {
    return axios/* default.post */.ZP.post("".concat(ApiUrl.REEL, "/").concat(reelId, "/reaction/LIKE"), body);
};
var deleteLike = function(reelId) {
    return axios/* default.delete */.ZP["delete"]("".concat(ApiUrl.REEL, "/").concat(reelId, "/reaction/LIKE"));
};
var trackReel = function(reelId, params) {
    return axios/* default.get */.ZP.get("".concat(ApiUrl.REEL, "/").concat(reelId, "/tracking"), {
        params: params
    });
};
var useFetchVideoReelsQuery = function(payload, options) {
    return (0,es.useQuery)([
        shared/* QueryKey.Reel */.S8.Reel,
        payload
    ], function() {
        return fetchVideoReels(payload);
    }, options);
};
var useFetchVideoReelQuery = function(payload, options) {
    return (0,es.useQuery)([
        shared/* QueryKey.Reel */.S8.Reel,
        payload
    ], function() {
        return getVideoDetail(payload);
    }, options);
};
var useFetchCommentsQuery = function(payload, options) {
    return (0,es.useQuery)([
        shared/* QueryKey.ReelComment */.S8.ReelComment,
        payload
    ], function() {
        return fetchComments(payload.reelId, payload.params);
    }, options);
};
var useFetchReplyCommentsQuery = function(payload, options) {
    return (0,es.useQuery)([
        shared/* QueryKey.ReelReplyComment */.S8.ReelReplyComment,
        payload
    ], function() {
        return fetchReplyComments(payload.commentId, payload.params);
    }, options);
};
var useCreateComment = function(options) {
    return (0,es.useMutation)(function(payload) {
        return createComment(payload);
    }, options);
};
var useUpdateComment = function(options) {
    return (0,es.useMutation)(function(payload) {
        return updateComment(payload);
    }, options);
};
var useDeleteComment = function(options) {
    return (0,es.useMutation)(function(payload) {
        return deleteComment(payload);
    }, options);
};
var useCreateReplyComment = function(options) {
    return (0,es.useMutation)(function(payload) {
        return createReplyComment(payload);
    }, options);
};
var useUpdateReplyComment = function(options) {
    return (0,es.useMutation)(function(payload) {
        return updateReplyComment(payload);
    }, options);
};
var useDeleteReplyComment = function(options) {
    return (0,es.useMutation)(function(payload) {
        return deleteReplyComment(payload);
    }, options);
};
var useCreateLike = function(options) {
    return (0,es.useMutation)(function(payload) {
        return createLike(payload.reelId, payload.body);
    }, options);
};
var useDeleteLike = function(options) {
    return (0,es.useMutation)(function(payload) {
        return deleteLike(payload);
    }, options);
};
var useTrackReel = function(reelId, options) {
    return (0,es.useQuery)([
        shared/* QueryKey.ReelTracking */.S8.ReelTracking,
        reelId
    ], function() {
        return trackReel(reelId, options);
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./features/reels/reducer.ts




var initialState = {
    data: VideoReelsDefault,
    filters: {
        limit: 5,
        offset: 0,
        sort_by: "created_at",
        sort: "desc"
    }
};
var reducer = function(state, action) {
    switch(action.type){
        case ActionType.OnLoadMore:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filters: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.filters), {
                    limit: action.payload.limit || state.filters.limit,
                    offset: action.payload.offset
                })
            });
        case ActionType.SetData:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: action.payload
            });
        case ActionType.AppendData:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: {
                    edges: (0,_to_consumable_array/* default */.Z)(state.data.edges).concat((0,_to_consumable_array/* default */.Z)(action.payload.edges)),
                    count: action.payload.count
                }
            });
        case ActionType.UpdateVideo:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.data), {
                    edges: state.data.edges.map(function(video) {
                        if (video.id === action.payload.id) {
                            return action.payload;
                        }
                        return video;
                    })
                })
            });
        case ActionType.ToggleLike:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.data), {
                    edges: state.data.edges.map(function(video) {
                        if (video.id === action.payload.id) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, video), {
                                is_liked: action.payload.is_liked,
                                like_count: action.payload.like_count
                            });
                        }
                        return video;
                    })
                })
            });
        default:
            return (0,_object_spread/* default */.Z)({}, initialState);
    }
};

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
// EXTERNAL MODULE: ./libs/cookies/index.ts + 1 modules
var cookies = __webpack_require__(47279);
;// CONCATENATED MODULE: ./features/reels/partials/Video.tsx










var Video = function(param) {
    var video = param.video, t = param.t, dispatch = param.dispatch, onToggleComment = param.onToggleComment, onPlayVideo = param.onPlayVideo;
    var isAuth = (0,cookies/* getAuth */.v0)().isAuth;
    var playerRef = (0,react.useRef)(null);
    var videoContainerRef = (0,react.useRef)(null);
    var contentRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isClamped = ref[0], setIsClamped = ref[1];
    var ref1 = (0,react.useState)(false), expanded = ref1[0], setExpanded = ref1[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var ref;
                var player = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                if (entry.isIntersecting) {
                    if (typeof (player === null || player === void 0 ? void 0 : player.playVideo) === "function") player.playVideo();
                    onPlayVideo();
                } else {
                    if (typeof (player === null || player === void 0 ? void 0 : player.pauseVideo) === "function") player.pauseVideo();
                }
            });
        }, {
            threshold: 0.5
        });
        var videoContainerElement = videoContainerRef.current;
        if (videoContainerElement) {
            observer.observe(videoContainerElement);
        }
        return function() {
            if (videoContainerElement) {
                observer.unobserve(videoContainerElement);
            }
        };
    }, [
        onPlayVideo
    ]);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var element = contentRef.current;
            if (element && element.scrollHeight > element.clientHeight) {
                setIsClamped(true);
            }
        }, 100);
    }, []);
    var ref2 = useDeleteLike(), dislike = ref2.mutate, loadingDislike = ref2.isLoading;
    var ref3 = useCreateLike(), like = ref3.mutate, loadingLike = ref3.isLoading;
    var ref4 = useTrackReel(video.id), trackReel = ref4.refetch, isTracking = ref4.isLoading;
    var handleLike = function(video) {
        if (!isAuth) {
            return react_hot_toast_esm/* default.error */.ZP.error(t("message.unauthorized"));
        }
        var likeCount = video.like_count;
        if (video.is_liked) {
            dislike(video.id);
            likeCount--;
        } else {
            like({
                reelId: video.id,
                body: null
            });
            likeCount++;
        }
        dispatch({
            type: ActionType.ToggleLike,
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, video), {
                is_liked: !video.is_liked,
                like_count: likeCount
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-relative tw-h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: videoContainerRef,
                    className: "tw-relative tw-h-full tw-bg-black tw-rounded-none sm:tw-rounded-lg tw-overflow-hidden tw-border-none sm:tw-border",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            url: video.youtube_video_url,
                            width: "100%",
                            height: "100%",
                            className: "react-player",
                            style: {
                                textAlign: "center",
                                backgroundColor: "black"
                            },
                            ref: playerRef,
                            playing: false,
                            controls: false,
                            loop: true,
                            onStart: function() {
                                trackReel();
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-left-4 tw-bottom-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-gap-x-2 tw-items-center tw-text-white tw-text-sm tw-mb-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                            src: video.staffs.avatar,
                                            className: "tw-w-7 tw-h-7",
                                            rounded: "tw-rounded-full"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "tw-font-semibold",
                                            dangerouslySetInnerHTML: {
                                                __html: video.staffs.fullname
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-text-white tw-text-sm tw-w-[280px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: contentRef,
                                            className: expanded ? "tw-font-light" : "text-2line tw-font-light",
                                            children: video.description
                                        }),
                                        isClamped && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return setExpanded(!expanded);
                                            },
                                            className: "tw-font-semibold tw-cursor-pointer",
                                            children: expanded ? "Ẩn bớt" : "Xem th\xeam"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-right-3 tw-bottom-3 sm:-tw-right-[60px] sm:tw-bottom-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-1 tw-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                        disabled: false,
                                        loading: false,
                                        onClick: function() {
                                            return handleLike(video);
                                        },
                                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-[40px] !tw-h-[40px] tw-bg-white/[.5] sm:tw-bg-primary-main/[.08] tw-border-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: "tw-text-white sm:tw-text-primary-main",
                                            icon: video.is_liked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondLikeFilledIcon */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondLikeIcon */.rQ, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-text-sm tw-font-light tw-text-white sm:tw-text-secondary-70",
                                        children: video.like_count
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-1 tw-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                        disabled: false,
                                        loading: false,
                                        onClick: function() {
                                            onToggleComment();
                                        },
                                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-[40px] !tw-h-[40px] tw-bg-white/[.5] sm:tw-bg-primary-main/[.08] tw-border-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: "tw-text-white sm:tw-text-primary-main",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommentIcon */.qt, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-text-sm tw-font-light tw-text-white sm:tw-text-secondary-70",
                                        children: video.total_comment_count
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex-col tw-gap-1 tw-items-center tw-hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    disabled: false,
                                    loading: false,
                                    onClick: function() {},
                                    className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-[40px] !tw-h-[40px] tw-bg-white/[.5] sm:tw-bg-primary-main/[.08] tw-border-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-text-white sm:tw-text-primary-main",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ShareIcon */.aA, {})
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partials_Video = (Video);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/vi.js
var vi = __webpack_require__(37553);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var contexts_profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./features/reels/partials/Comment.tsx







var Comment = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var comment = props.comment, _isChild = props.isChild, isChild = _isChild === void 0 ? false : _isChild, isShowReplyInput = props.isShowReplyInput, replyCommentContent = props.replyCommentContent, setReplyCommentContent = props.setReplyCommentContent, setReplyCommentInput = props.setReplyCommentInput, editCommentInput = props.editCommentInput, setEditCommentInput = props.setEditCommentInput, editCommentContent = props.editCommentContent, setEditCommentContent = props.setEditCommentContent, onShowReplyInput = props.onShowReplyInput, onSetReplies = props.onSetReplies, onSendReplyComment = props.onSendReplyComment, t = props.t, profile = props.profile, isAuth = props.isAuth;
    var ref6 = (0,react.useState)(false), isExpandingReplies = ref6[0], setIsExpandingReplies = ref6[1];
    var ref7 = (0,react.useState)(null), commentToExpand = ref7[0], setCommentToExpand = ref7[1];
    var ref8 = (0,react.useState)(false), isShowConfirmDelete = ref8[0], setIsShowConfirmDelete = ref8[1];
    var ref9 = useFetchReplyCommentsQuery({
        commentId: Number(commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.id),
        params: {
            limit: commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.reply_comment_count
        }
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data, total_records = param.total_records;
            var replies = Array.isArray(data) ? data : [];
            onSetReplies(Number(commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.id), replies);
        }
    }), fetchReplyComments = ref9.refetch, isLoadingReplyComments = ref9.isLoading;
    var ref10 = useDeleteComment(), deleteComment = ref10.mutate, isDeletingComment = ref10.isLoading;
    var ref11 = useDeleteReplyComment(), deleteReplyComment = ref11.mutate, isDeletingReplyComment = ref11.isLoading;
    var ref12 = useUpdateComment(), updateComment = ref12.mutate, isUpdatingComment = ref12.isLoading;
    var ref13 = useUpdateReplyComment(), updateReplyComment = ref13.mutate, isUpdatingReplyComment = ref13.isLoading;
    (0,react.useEffect)(function() {
        if (commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.id) {
            fetchReplyComments();
        }
    }, [
        commentToExpand,
        fetchReplyComments
    ]);
    var handleToggleShowReply = function(comment) {
        if (isExpandingReplies) {
            setCommentToExpand(null);
            setIsExpandingReplies(false);
            if (isShowReplyInput) {
                setReplyCommentInput(null);
            }
        } else {
            setCommentToExpand(comment);
            setIsExpandingReplies(true);
        }
    };
    var handleKeyPress = function(e) {
        if (e.keyCode === 13) {
            onSendReplyComment();
        }
    };
    var handleEditKeyPress = function(e) {
        if (e.keyCode === 13) {
            handleEditComment();
        }
    };
    var handleDeleteComment = function() {
        if (isChild) {
            deleteReplyComment(comment.id);
        } else {
            deleteComment(comment.id);
        }
        setIsShowConfirmDelete(false);
    };
    var handleEditComment = function() {
        if (isChild) {
            updateReplyComment({
                commentId: editCommentInput.commentId,
                body: {
                    comment: editCommentContent
                }
            });
        } else {
            updateComment({
                commentId: editCommentInput.commentId,
                body: {
                    comment: editCommentContent
                }
            });
        }
        setEditCommentInput(null);
    };
    var showEditComment = function() {
        setEditCommentInput({
            commentId: comment.id
        });
        setEditCommentContent(comment.comment);
    };
    var isOwner = function() {
        var ref;
        return profile && profile.id === ((ref = comment.users) === null || ref === void 0 ? void 0 : ref.id);
    };
    var isEdit = function() {
        return Boolean((editCommentInput === null || editCommentInput === void 0 ? void 0 : editCommentInput.commentId) === comment.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(isChild ? "tw-mb-2" : "tw-mb-5"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-start tw-gap-2 tw-mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                src: ((ref = comment.users) === null || ref === void 0 ? void 0 : ref.avatar) || ((ref1 = comment.staffs) === null || ref1 === void 0 ? void 0 : ref1.avatar) || "",
                                className: "tw-w-8 tw-h-8",
                                rounded: "tw-rounded-full"
                            }),
                            isEdit() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex-grow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Input */.II, {
                                    containerClassName: "tw-rounded-full tw-px-4",
                                    className: "tw-text-sm",
                                    variant: components/* InputVariant.Outlined */.Jf.Outlined,
                                    placeholder: t("placeholder.comment") + "...",
                                    value: editCommentContent,
                                    onChange: function(e) {
                                        return setEditCommentContent(e.target.value);
                                    },
                                    onKeyDown: function(e) {
                                        return handleEditKeyPress(e);
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex-grow tw-text-sm tw-max-w-[calc(100%-40px)]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-gap-2 tw-mb-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-font-semibold",
                                                children: ((ref2 = comment.users) === null || ref2 === void 0 ? void 0 : ref2.fullname) || ((ref3 = comment.staffs) === null || ref3 === void 0 ? void 0 : ref3.fullname)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-w-0.5 tw-h-0.5 tw-rounded-full tw-bg-secondary-70"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-secondary-70 tw-font-light",
                                                children: dayjs_min_default()(comment.updated_at).format("HH:mm DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-font-light tw-mb-1 tw-break-words",
                                        children: comment.comment
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-text-primary-main tw-cursor-pointer tw-flex tw-items-center tw-gap-1",
                                                    onClick: function() {
                                                        if (!isAuth) {
                                                            return react_hot_toast_esm/* default.error */.ZP.error(t("message.unauthorized"));
                                                        }
                                                        onShowReplyInput(comment);
                                                        if (!isChild) {
                                                            setCommentToExpand(comment);
                                                            setIsExpandingReplies(true);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                            className: "tw-w-[14px]",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommentIcon */.qt, {
                                                                width: 14,
                                                                height: 14
                                                            })
                                                        }),
                                                        t("button.reply")
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    isOwner() && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-primary-main tw-cursor-pointer",
                                                        onClick: function() {
                                                            return showEditComment();
                                                        },
                                                        children: t("button.edit")
                                                    }),
                                                    isOwner() && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-ml-4 tw-text-[#333333] tw-cursor-pointer",
                                                        onClick: function() {
                                                            return setIsShowConfirmDelete(true);
                                                        },
                                                        children: t("button.delete")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    comment.reply_comment_count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer",
                                onClick: function() {
                                    return handleToggleShowReply(comment);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-w-6 tw-h-[2px] tw-bg-gray-41"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-sm tw-text-gray-41",
                                        children: isExpandingReplies ? t("label.hide-replies") : t("label.number-replies", {
                                            value: comment.reply_comment_count
                                        })
                                    })
                                ]
                            }),
                            isExpandingReplies && Number((ref4 = comment.reel_reply_comments) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-pl-6 tw-pt-2 tw-flex tw-flex-col-reverse",
                                children: (ref5 = comment.reel_reply_comments) === null || ref5 === void 0 ? void 0 : ref5.map(function(replyComment) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment, {
                                        t: t,
                                        profile: profile,
                                        isAuth: isAuth,
                                        comment: replyComment,
                                        isChild: true,
                                        isShowReplyInput: isShowReplyInput,
                                        replyCommentContent: replyCommentContent,
                                        setReplyCommentContent: setReplyCommentContent,
                                        setReplyCommentInput: setReplyCommentInput,
                                        editCommentInput: editCommentInput,
                                        setEditCommentInput: setEditCommentInput,
                                        editCommentContent: editCommentContent,
                                        setEditCommentContent: setEditCommentContent,
                                        onShowReplyInput: onShowReplyInput,
                                        onSetReplies: onSetReplies,
                                        onSendReplyComment: onSendReplyComment
                                    }, "comment-".concat(replyComment.id));
                                })
                            })
                        ]
                    }),
                    !isChild && isShowReplyInput && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "transition-height tw-pl-6 tw-h-auto tw-mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                    src: profile === null || profile === void 0 ? void 0 : profile.avatar,
                                    className: "tw-w-8 tw-h-8",
                                    rounded: "tw-rounded-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex-grow tw-relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Input */.II, {
                                            containerClassName: "tw-rounded-full tw-px-4",
                                            className: "tw-text-sm",
                                            variant: components/* InputVariant.Outlined */.Jf.Outlined,
                                            placeholder: t("placeholder.reply-comment") + "...",
                                            value: replyCommentContent,
                                            onChange: function(e) {
                                                return setReplyCommentContent(e.target.value);
                                            },
                                            onKeyDown: function(e) {
                                                return handleKeyPress(e);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-absolute tw-r-0 tw-b-0"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            isShowConfirmDelete && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalCustom */.wW, {
                className: "tw-w-[360px]",
                onClose: function() {
                    return setIsShowConfirmDelete(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-font-bold tw-text-lg tw-text-center",
                            children: "X\xf3a b\xecnh luận"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Bạn c\xf3 chắn chắn muốn x\xf3a b\xecnh luận n\xe0y?"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-justify-end tw-gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                    className: "tw-border-secondary-70 tw-text-secondary-70",
                                    onClick: function() {
                                        return setIsShowConfirmDelete(false);
                                    },
                                    children: "Hủy"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                    variant: components/* ButtonVariant.Standard */.Wu.Standard,
                                    className: "tw-bg-red-600/70 tw-border-red-600/70",
                                    onClick: handleDeleteComment,
                                    children: "X\xf3a"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var partials_Comment = (/*#__PURE__*/react.memo(Comment));

;// CONCATENATED MODULE: ./features/reels/partials/Comments.tsx


















var InputType;
(function(InputType) {
    InputType[InputType["CommentInput"] = 0] = "CommentInput";
    InputType[InputType["ReplyInput"] = 1] = "ReplyInput";
})(InputType || (InputType = {}));
var Comments = function(param) {
    var video = param.video, show = param.show, t = param.t, dispatch = param.dispatch, onCloseComment = param.onCloseComment;
    var ref;
    var ref1 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            comment: ""
        },
        resolver: (0,yup_module/* yupResolver */.X)(yup_es/* object */.Ry({
            comment: yup_es/* string */.Z_().trim().required(t("message.comment-required"))
        }))
    }), reset = ref1.reset, control = ref1.control, handleSubmit = ref1.handleSubmit, errors = ref1.formState.errors;
    var ref2 = (0,cookies/* getAuth */.v0)(), token = ref2.token, isAuth = ref2.isAuth;
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var commentsContainerRef = (0,react.useRef)(null);
    var commentRef = (0,react.useRef)(null);
    var clientRef = (0,react.useRef)(null);
    var timeout = (0,react.useRef)(null);
    var ref3 = (0,react.useState)([]), comments = ref3[0], setComments = ref3[1];
    var ref4 = (0,react.useState)(0), total = ref4[0], setTotal = ref4[1];
    var ref5 = (0,react.useState)(null), commentToExpand = ref5[0], setCommentToExpand = ref5[1];
    var ref6 = (0,react.useState)(null), replyCommentInput = ref6[0], setReplyCommentInput = ref6[1];
    var ref7 = (0,react.useState)(""), replyCommentContent = ref7[0], setReplyCommentContent = ref7[1];
    var ref8 = (0,react.useState)(null), editCommentInput = ref8[0], setEditCommentInput = ref8[1];
    var ref9 = (0,react.useState)(""), editCommentContent = ref9[0], setEditCommentContent = ref9[1];
    var ref10 = (0,react.useState)(null), waitingToReconnect = ref10[0], setWaitingToReconnect = ref10[1];
    var ref11 = useFetchCommentsQuery({
        reelId: video.id,
        params: {
            offset: comments.length,
            reply_limit: 50
        }
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data, total_records = param.total_records;
            var _comments = Array.isArray(data) ? data : [];
            setComments(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(_comments));
            });
            setTotal(total_records);
        }
    }), fetchComments = ref11.refetch, isLoadingComments = ref11.isLoading;
    var ref12 = useFetchReplyCommentsQuery({
        commentId: Number(commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.id),
        params: {
            limit: commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.reply_comment_count
        }
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data, total_records = param.total_records;
            var replies = Array.isArray(data) ? data : [];
            setRepliesToComment(Number(commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.id), replies);
        }
    }), fetchReplyComments = ref12.refetch, isLoadingReplyComments = ref12.isLoading;
    var ref13 = useFetchVideoReelQuery(video.id, {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            dispatch({
                type: ActionType.UpdateVideo,
                payload: data
            });
        }
    }), getVideoDetail = ref13.refetch, isLoadingVideoDetail = ref13.isLoading;
    var ref14 = useCreateComment(), createComment = ref14.mutate, isCreatingComment = ref14.isLoading;
    var ref15 = useCreateReplyComment(), createReplyComment = ref15.mutate, isCreatingReplyComment = ref15.isLoading;
    (0,react.useEffect)(function() {
        if (show) {
            fetchComments();
        } else {
            setComments([]);
            setTotal(0);
            setReplyCommentInput(null);
            setEditCommentInput(null);
        }
    }, [
        show,
        fetchComments
    ]);
    (0,react.useEffect)(function() {
        if (commentToExpand === null || commentToExpand === void 0 ? void 0 : commentToExpand.id) {
            fetchReplyComments();
        }
    }, [
        commentToExpand,
        fetchReplyComments
    ]);
    (0,react.useEffect)(function() {
        if (replyCommentInput) {
            setEditCommentInput(null);
        } else {
            setReplyCommentContent("");
        }
    }, [
        replyCommentInput
    ]);
    (0,react.useEffect)(function() {
        if (editCommentInput) {
            setReplyCommentInput(null);
        } else {
            setEditCommentContent("");
        }
    }, [
        editCommentInput
    ]);
    (0,react.useEffect)(function() {
        if (waitingToReconnect || clientRef.current || !isAuth || !show) return;
        var ws = new WebSocket("".concat("wss://api.anthu.tech/ws/realtime" || 0, "?token=").concat(token));
        clientRef.current = ws;
        ws.onopen = function() {
            var socketPayload = {
                method: "subscribe",
                type: "unicast",
                channels: [
                    {
                        id: shared/* SocketChanel.Reel */.y1.Reel,
                        object_id: video.id
                    }
                ]
            };
            ws.send(JSON.stringify(socketPayload));
            timeout.current = setInterval(function() {
                var socketPayload = {
                    method: "ping"
                };
                ws.send(JSON.stringify(socketPayload));
            }, 15000);
            console.log("open connect");
        };
        ws.onmessage = function(event) {
            var jsonData = JSON.parse(event.data);
            console.log("json: ", jsonData);
            if (typeof jsonData === "object" && (jsonData === null || jsonData === void 0 ? void 0 : jsonData.data)) {
                if (jsonData.method === shared/* ReelMethod.CreateComment */.vi.CreateComment) {
                    setComments(function(prev) {
                        return (0,_to_consumable_array/* default */.Z)([
                            jsonData.data
                        ]).concat((0,_to_consumable_array/* default */.Z)(prev));
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.CreateRelyComment */.vi.CreateRelyComment) {
                    setComments(function(prev) {
                        var newCommentList = prev === null || prev === void 0 ? void 0 : prev.map(function(comment) {
                            var ref;
                            if (comment.id === ((ref = jsonData.data) === null || ref === void 0 ? void 0 : ref.reel_comment_id)) {
                                var _reel_reply_comments;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                                    reply_comment_count: comment.reply_comment_count + 1,
                                    reel_reply_comments: (0,_to_consumable_array/* default */.Z)([
                                        jsonData.data
                                    ]).concat((0,_to_consumable_array/* default */.Z)((_reel_reply_comments = comment.reel_reply_comments) !== null && _reel_reply_comments !== void 0 ? _reel_reply_comments : []))
                                });
                            }
                            return comment;
                        });
                        return newCommentList;
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.UpdateComment */.vi.UpdateComment) {
                    setComments(function(prev) {
                        return prev.map(function(comment) {
                            if (comment.id === jsonData.data.id) {
                                return (0,_object_spread/* default */.Z)({}, comment, jsonData.data);
                            }
                            return comment;
                        });
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.UpdateRelyComment */.vi.UpdateRelyComment) {
                    setComments(function(prev) {
                        var newComments = prev.map(function(comment) {
                            if (comment.id === jsonData.data.reel_comment_id) {
                                var ref;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                                    reel_reply_comments: (ref = comment.reel_reply_comments) === null || ref === void 0 ? void 0 : ref.map(function(reply) {
                                        if (reply.id === jsonData.data.id) {
                                            return jsonData.data;
                                        }
                                        return reply;
                                    })
                                });
                            }
                            return comment;
                        });
                        return newComments;
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.DeleteComment */.vi.DeleteComment) {
                    setComments(function(prev) {
                        return prev.filter(function(comment) {
                            return comment.id !== jsonData.data.id;
                        });
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.HideComment */.vi.HideComment) {
                    setComments(function(prev) {
                        return prev.filter(function(comment) {
                            return comment.id !== jsonData.data.id;
                        });
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.DeleteRelyComment */.vi.DeleteRelyComment) {
                    setComments(function(prev) {
                        var newComments = prev.map(function(comment) {
                            if (comment.id === jsonData.data.comment_id) {
                                var ref;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                                    reply_comment_count: comment.reply_comment_count - 1,
                                    reel_reply_comments: (ref = comment.reel_reply_comments) === null || ref === void 0 ? void 0 : ref.filter(function(reply) {
                                        return reply.id !== jsonData.data.reply_comment_id;
                                    })
                                });
                            }
                            return comment;
                        });
                        return newComments;
                    });
                    getVideoDetail();
                    return;
                }
                if (jsonData.method === shared/* ReelMethod.HideReplyComment */.vi.HideReplyComment) {
                    setComments(function(prev) {
                        var newComments = prev.map(function(comment) {
                            if (comment.id === jsonData.data.reel_comment_id) {
                                var ref;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                                    reply_comment_count: comment.reply_comment_count - 1,
                                    reel_reply_comments: (ref = comment.reel_reply_comments) === null || ref === void 0 ? void 0 : ref.filter(function(reply) {
                                        return reply.id !== jsonData.data.id;
                                    })
                                });
                            }
                            return comment;
                        });
                        return newComments;
                    });
                    getVideoDetail();
                    return;
                }
            }
        };
        ws.onclose = function() {
            if (clientRef.current) {
                console.log("ws closed by server");
            } else {
                console.log("ws closed by app component unmount");
                return;
            }
            setWaitingToReconnect(true);
            setTimeout(function() {
                return setWaitingToReconnect(null);
            }, 5000);
        };
        return function() {
            ws.close();
            clearInterval(timeout.current);
            clientRef.current = null;
            timeout.current = null;
        };
    }, [
        video.id,
        waitingToReconnect,
        show,
        getVideoDetail,
        isAuth,
        token
    ]);
    var handleLoadMoreComments = function() {
        fetchComments();
    };
    var setRepliesToComment = function(commentId, replies) {
        setComments(function(prev) {
            return prev.map(function(comment) {
                if (comment.id === commentId) {
                    comment.reel_reply_comments = (0,_to_consumable_array/* default */.Z)(replies);
                }
                return comment;
            });
        });
    };
    var sendComment = handleSubmit(function(data) {
        if (!isAuth) {
            return react_hot_toast_esm/* default.error */.ZP.error(t("message.unauthorized"));
        }
        if (!data.comment) return;
        createComment({
            reelId: video.id,
            body: data
        });
        reset();
    });
    var sendReplyComment = function() {
        if (!replyCommentInput || !replyCommentContent) return;
        createReplyComment({
            commentId: replyCommentInput.commentId,
            body: {
                comment: replyCommentContent
            }
        });
        setReplyCommentInput(null);
    };
    var handleKeyPress = function(e, type) {
        if (e.keyCode === 13) {
            if (type === InputType.CommentInput) {
                sendComment();
            } else if (type === InputType.ReplyInput) {
                sendReplyComment();
            }
        }
    };
    var handleShowReplyInput = function(comment) {
        var commentId = comment.reel_comment_id || comment.id;
        if ((replyCommentInput === null || replyCommentInput === void 0 ? void 0 : replyCommentInput.replyId) === comment.id) {
            setReplyCommentInput({
                commentId: commentId,
                replyId: comment.id,
                isShow: !(replyCommentInput === null || replyCommentInput === void 0 ? void 0 : replyCommentInput.isShow),
                taggedUser: comment.users || comment.staffs
            });
        }
        if ((replyCommentInput === null || replyCommentInput === void 0 ? void 0 : replyCommentInput.replyId) !== comment.id) {
            setReplyCommentInput({
                commentId: commentId,
                replyId: comment.id,
                isShow: true,
                taggedUser: comment.users || comment.staffs
            });
        }
    };
    (0,react.useEffect)(function() {
        if (replyCommentInput === null || replyCommentInput === void 0 ? void 0 : replyCommentInput.isShow) {
            if (replyCommentInput.taggedUser) {
                setReplyCommentContent("@" + replyCommentInput.taggedUser.fullname + " ");
            }
        } else {
            setReplyCommentContent("");
        }
    }, [
        replyCommentInput
    ]);
    var isShowReplyInput = function(comment) {
        return (replyCommentInput === null || replyCommentInput === void 0 ? void 0 : replyCommentInput.isShow) && (replyCommentInput === null || replyCommentInput === void 0 ? void 0 : replyCommentInput.commentId) === comment.id;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-w-full tw-h-full tw-border tw-border-[#EEF0F5] tw-rounded-t-lg sm:tw-rounded-lg tw-overflow-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-h-full tw-w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-justify-between tw-h-[40px] tw-px-4 tw-py-2 tw-bg-[#EEF0F5]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-text-secondary-70 tw-text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-font-semibold",
                                        children: t("label.comment")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-ml-2 tw-font-light",
                                        children: video.total_comment_count
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-cursor-pointer",
                                onClick: onCloseComment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XNewIcon */.HW, {}),
                                    className: "tw-w-6 tw-h-6"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "scroll-container-".concat(video.id),
                        ref: commentsContainerRef,
                        className: "tw-flex-1 tw-p-0 tw-h-[calc(100%-40px-48px)] tw-overflow-y-hidden tw-bg-white",
                        children: comments.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                            dataLength: comments.length,
                            next: handleLoadMoreComments,
                            hasMore: comments.length < total,
                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            scrollableTarget: "scroll-container-".concat(video.id),
                            inverse: true,
                            className: "tw-h-full tw-flex tw-flex-col-reverse tw-px-4 tw-py-2",
                            height: (commentsContainerRef === null || commentsContainerRef === void 0 ? void 0 : (ref = commentsContainerRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 32,
                            ref: commentRef,
                            children: comments.map(function(comment) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Comment, {
                                    comment: comment,
                                    isChild: false,
                                    isShowReplyInput: isShowReplyInput(comment),
                                    setReplyCommentInput: setReplyCommentInput,
                                    replyCommentContent: replyCommentContent,
                                    setReplyCommentContent: setReplyCommentContent,
                                    editCommentInput: editCommentInput,
                                    setEditCommentInput: setEditCommentInput,
                                    editCommentContent: editCommentContent,
                                    setEditCommentContent: setEditCommentContent,
                                    onShowReplyInput: handleShowReplyInput,
                                    onSetReplies: setRepliesToComment,
                                    onSendReplyComment: sendReplyComment,
                                    t: t,
                                    profile: profile,
                                    isAuth: isAuth
                                }, comment.id);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-px-4 tw-py-2",
                            children: t("message.no-comments")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-x-2 tw-h-[49px] tw-px-4 tw-bg-[#EEF0F5] tw-border-t",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                                name: "comment",
                                control: control,
                                showErrorMessage: false,
                                variant: components/* InputVariant.Outlined */.Jf.Outlined,
                                placeholder: t("placeholder.comment") + "...",
                                wrapperClassName: "tw-flex-grow tw-h-10",
                                containerClassName: "tw-bg-white tw-rounded-full !tw-border-0 tw-border-white tw-flex-1",
                                className: "tw-px-2 tw-text-sm custom-placeholder",
                                onKeyDown: function(e) {
                                    return handleKeyPress(e, InputType.CommentInput);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                                onClick: function() {
                                    sendComment();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: "tw-w-4 tw-h-4",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SendIcon */.jE, {})
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var partials_Comments = (Comments);

;// CONCATENATED MODULE: ./features/reels/partials/Post.tsx




var Post = function(param) {
    var video = param.video, t = param.t, dispatch = param.dispatch, onPlayVideo = param.onPlayVideo;
    var ref = (0,react.useState)(false), isShowComment = ref[0], setIsShowComment = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "video-".concat(video.id),
            className: "tw-relative tw-flex tw-items-center tw-justify-center tw-gap-[80px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-[100vw] tw-h-[calc(100dvh-70px)] sm:tw-w-[270px] sm:tw-h-[480px] xl:tw-w-[304px] xl:tw-h-[540px] 2xl:tw-w-[366px] 2xl:tw-h-[650px] 3xl:tw-w-[405px] 3xl:tw-h-[720px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Video, {
                        video: video,
                        t: t,
                        dispatch: dispatch,
                        onToggleComment: function() {
                            return setIsShowComment(!isShowComment);
                        },
                        onPlayVideo: function() {
                            return onPlayVideo(video);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(isShowComment ? "animate-expanding" : "tw-hidden", " tw-absolute tw-top-[80px] tw-pb-[70px] sm:tw-relative sm:tw-top-0 sm:tw-pb-0 tw-w-[100vw] tw-h-[calc(100dvh-80px)] sm:tw-w-[270px] sm:tw-max-w-[405px] sm:tw-h-[480px] xl:tw-w-[304px] xl:tw-h-[540px] 2xl:tw-w-[366px] 2xl:tw-h-[650px] 3xl:tw-w-[405px] 3xl:tw-max-w-[405px] 3xl:tw-h-[720px] tw-overflow-hidden"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Comments, {
                        show: isShowComment,
                        video: video,
                        t: t,
                        dispatch: dispatch,
                        onCloseComment: function() {
                            setIsShowComment(false);
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partials_Post = (Post);

;// CONCATENATED MODULE: ./features/reels/layout.tsx









var ReelListLayout = function() {
    var t = (0,esm/* useTranslation */.$G)("reel").t;
    var ref = (0,react.useReducer)(reducer, initialState), ref1 = ref[0], data = ref1.data, filters = ref1.filters, dispatch = ref[1];
    var videos = data.edges, count = data.count;
    var ref2 = useFetchVideoReelsQuery(videoReelsQueryBuilder(filters), {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data, total_records = param.total_records;
            var edges = Array.isArray(data) ? data : [];
            dispatch({
                type: ActionType.AppendData,
                payload: {
                    edges: edges,
                    count: +total_records
                }
            });
        }
    }), refetch = ref2.refetch, isLoading = ref2.isLoading;
    (0,react.useEffect)(function() {
        refetch();
    }, [
        refetch,
        filters
    ]);
    var handleLoadMore = (0,react.useCallback)(function() {
        dispatch({
            type: ActionType.OnLoadMore,
            payload: {
                offset: videos.length
            }
        });
    }, [
        videos
    ]);
    var ref3 = (0,react.useState)(null), playingVideo = ref3[0], setPlayingVideo = ref3[1];
    var handlePlayVideo = function(video) {
        setPlayingVideo(video);
    };
    var ref4 = (0,react.useState)(false), isStickyHeader = ref4[0], setIsStickyHeader = ref4[1];
    (0,react.useEffect)(function() {
        var header = document.getElementById("no-sticky");
        var headerHeight = (header === null || header === void 0 ? void 0 : header.offsetHeight) || 0;
        var scrollCallBack = function() {
            if (window.scrollY > headerHeight) {
                setIsStickyHeader(true);
            } else {
                setIsStickyHeader(false);
            }
        };
        window.addEventListener("scroll", scrollCallBack);
        return function() {
            return window.removeEventListener("scroll", scrollCallBack);
        };
    });
    (0,react.useEffect)(function() {
        var index = videos.findIndex(function(item) {
            return item.id === (playingVideo === null || playingVideo === void 0 ? void 0 : playingVideo.id);
        });
        if (index !== -1 && index > videos.length - 4 && videos.length < count) {
            handleLoadMore();
        }
    }, [
        playingVideo,
        videos,
        count,
        handleLoadMore
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: t("list.title"),
                description: t("list.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container tw-pt-3 2xl:tw-pt-6 3xl:tw-pt-12 ".concat(isStickyHeader ? "tw-mt-[100px]" : "md:tw-border-t tw-border-primary-main"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "!tw-overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-fixed sm:tw-relative tw-top-0 tw-left-0 tw-z-[1000] sm:tw-z-0 tw-h-[calc(100dvh-70px)] sm:tw-h-auto xl:tw-h-[540px] 2xl:tw-h-[650px] 3xl:tw-h-[720px] tw-w-full tw-overflow-y-scroll tw-pr-5 tw-box-content sm:tw-space-y-20 tw-snap-y tw-snap-mandatory",
                        children: videos.map(function(video) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:tw-mb-[60px] tw-snap-center tw-snap-always",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_Post, {
                                    video: video,
                                    t: t,
                                    dispatch: dispatch,
                                    onPlayVideo: function(video) {
                                        return handlePlayVideo(video);
                                    }
                                })
                            }, "post-".concat(video.id));
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var layout = (ReelListLayout);

;// CONCATENATED MODULE: ./features/reels/index.tsx

/* harmony default export */ var reels = (layout);

;// CONCATENATED MODULE: ./pages/reels/index.tsx


var ReelListPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(reels, {});
};
var __N_SSP = true;
/* harmony default export */ var pages_reels = (ReelListPage);


/***/ }),

/***/ 58533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent',
};
var defaultThreshold = {
    unit: ThresholdUnits.Percent,
    value: 0.8,
};
function parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') {
        return {
            unit: ThresholdUnits.Percent,
            value: scrollThreshold * 100,
        };
    }
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
            return {
                unit: ThresholdUnits.Pixel,
                value: parseFloat(scrollThreshold),
            };
        }
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
            return {
                unit: ThresholdUnits.Percent,
                value: parseFloat(scrollThreshold),
            };
        }
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return defaultThreshold;
}

var InfiniteScroll = /** @class */ (function (_super) {
    __extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function () {
            if (_this.props.scrollableTarget instanceof HTMLElement)
                return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') {
                return document.getElementById(_this.props.scrollableTarget);
            }
            if (_this.props.scrollableTarget === null) {
                console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            }
            return null;
        };
        _this.onStart = function (evt) {
            if (_this.lastScrollTop)
                return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) {
                _this.startY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.startY = evt.touches[0].pageY;
            }
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function (evt) {
            if (!_this.dragging)
                return;
            if (evt instanceof MouseEvent) {
                _this.currentY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.currentY = evt.touches[0].pageY;
            }
            // user is scrolling down to up
            if (_this.currentY < _this.startY)
                return;
            if (_this.currentY - _this.startY >=
                Number(_this.props.pullDownToRefreshThreshold)) {
                _this.setState({
                    pullToRefreshThresholdBreached: true,
                });
            }
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5)
                return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY -
                    _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function () {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false,
                });
            }
            requestAnimationFrame(function () {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function (event) {
            if (typeof _this.props.onScroll === 'function') {
                // Execute this callback in next tick so that it does not affect the
                // functionality of the library.
                setTimeout(function () { return _this.props.onScroll && _this.props.onScroll(event); }, 0);
            }
            var target = _this.props.height || _this._scrollableNode
                ? event.target
                : document.documentElement.scrollTop
                    ? document.documentElement
                    : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered)
                return;
            var atBottom = _this.props.inverse
                ? _this.isElementAtTop(target, _this.props.scrollThreshold)
                : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({ showLoader: true });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength,
        };
        _this.throttledOnScrollListener = throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function () {
        if (typeof this.props.dataLength === 'undefined') {
            throw new Error("mandatory prop \"dataLength\" is missing. The prop is needed" +
                " when loading more content. Check README.md for usage");
        }
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height
            ? this._infScroll
            : this._scrollableNode || window;
        if (this.el) {
            this.el.addEventListener('scroll', this
                .throttledOnScrollListener);
        }
        if (typeof this.props.initialScrollY === 'number' &&
            this.el &&
            this.el instanceof HTMLElement &&
            this.el.scrollHeight > this.props.initialScrollY) {
            this.el.scrollTo(0, this.props.initialScrollY);
        }
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance =
                (this._pullDown &&
                    this._pullDown.firstChild &&
                    this._pullDown.firstChild.getBoundingClientRect()
                        .height) ||
                    0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') {
                throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
            }
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function () {
        if (this.el) {
            this.el.removeEventListener('scroll', this
                .throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function (prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength)
            return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false,
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function (nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) {
            return __assign(__assign({}, prevState), { prevDataLength: nextProps.dataLength });
        }
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop <=
                threshold.value + clientHeight - target.scrollHeight + 1);
        }
        return (target.scrollTop <=
            threshold.value / 100 + clientHeight - target.scrollHeight + 1);
    };
    InfiniteScroll.prototype.isElementAtBottom = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop + clientHeight >= target.scrollHeight - threshold.value);
        }
        return (target.scrollTop + clientHeight >=
            (threshold.value / 100) * target.scrollHeight);
    };
    InfiniteScroll.prototype.render = function () {
        var _this = this;
        var style = __assign({ height: this.props.height || 'auto', overflow: 'auto', WebkitOverflowScrolling: 'touch' }, this.props.style);
        var hasChildren = this.props.hasChildren ||
            !!(this.props.children &&
                this.props.children instanceof Array &&
                this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height
            ? { overflow: 'auto' }
            : {};
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: outerDivStyle, className: "infinite-scroll-component__outerdiv" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "infinite-scroll-component " + (this.props.className || ''), ref: function (infScroll) { return (_this._infScroll = infScroll); }, style: style },
                this.props.pullDownToRefresh && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { position: 'relative' }, ref: function (pullDown) { return (_this._pullDown = pullDown); } },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: -1 * this.maxPullDownDistance,
                        } }, this.state.pullToRefreshThresholdBreached
                        ? this.props.releaseToRefreshContent
                        : this.props.pullDownToRefreshContent))),
                this.props.children,
                !this.state.showLoader &&
                    !hasChildren &&
                    this.props.hasMore &&
                    this.props.loader,
                this.state.showLoader && this.props.hasMore && this.props.loader,
                !this.props.hasMore && this.props.endMessage)));
    };
    return InfiniteScroll;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));

/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);
//# sourceMappingURL=index.es.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2004,9774,2888,179], function() { return __webpack_exec__(65468); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);